var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "details",
    { staticClass: "card card--collapsible", attrs: { open: "" } },
    [
      _c("summary", { staticClass: "card__title card__title--bg-secondary" }, [
        _c("h5", [_vm._v(_vm._s(_vm.modelValue.title))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c(
              "div",
              { staticClass: "table-responsive" },
              [
                _c("vue-good-table", {
                  attrs: {
                    columns: [
                      {
                        label: "Conciliado",
                        field: "conciliado",
                        filterable: false
                      },
                      {
                        label: "# Documento",
                        field: "numero_documento",
                        filterable: true
                      },
                      {
                        label: "Fecha de emisión",
                        field: "fecha_emision",
                        filterable: true
                      },
                      {
                        label: "Cliente",
                        field: "nombre_cliente",
                        filterable: true
                      },
                      {
                        label: "Subtotal",
                        field: "subtotal",
                        filterable: false
                      },
                      {
                        label: "Margen",
                        field: "margen",
                        filterable: false
                      },
                      {
                        label: "IVA",
                        field: "valor_iva",
                        filterable: false
                      },
                      {
                        label: "Total",
                        field: "valor_total",
                        filterable: false
                      },
                      {
                        label: "",
                        field: "acciones"
                      }
                    ],
                    "pagination-options": {
                      enabled: false
                    },
                    rows: _vm.modelValue.comprobantes,
                    "search-options": {
                      enabled: true,
                      placeholder: "Buscar..."
                    },
                    styleClass: "vgt-table"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "table-row",
                      fn: function(props) {
                        return [
                          props.column.field === "numero_documento"
                            ? _c("span", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(props.row.codigo_establecimiento) +
                                    "-" +
                                    _vm._s(props.row.codigo_emisor) +
                                    "-" +
                                    _vm._s(props.row.numero_secuencial) +
                                    "\n                            "
                                )
                              ])
                            : props.column.field === "subtotal" ||
                              props.column.field === "valor_iva" ||
                              props.column.field === "valor_total"
                            ? _c("span", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.moneyFormat(
                                        props.formattedRow[props.column.field]
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ])
                            : props.column.field === "margen"
                            ? _c(
                                "span",
                                [
                                  _c("input-field", {
                                    attrs: {
                                      readonly: !_vm.permiteEditarComision,
                                      placeholder: "$ #,###.##",
                                      vMoney: "",
                                      format: _vm.moneyNegative,
                                      id:
                                        "margenes" +
                                        _vm.modelValue.title +
                                        props.row.originalIndex
                                    },
                                    on: {
                                      blur: function($event) {
                                        return _vm.blurMargen(
                                          props.row.originalIndex
                                        )
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.modelValue.comprobantes[
                                          props.row.originalIndex
                                        ].margen,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.modelValue.comprobantes[
                                            props.row.originalIndex
                                          ],
                                          "margen",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "modelValue.comprobantes[props.row.originalIndex].margen"
                                    }
                                  })
                                ],
                                1
                              )
                            : props.column.field === "conciliado"
                            ? _c("span", [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for:
                                        "conciliado" +
                                        props.index +
                                        _vm.modelValue.title
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.modelValue.comprobantes[
                                              props.row.originalIndex
                                            ].conciliado,
                                          expression:
                                            "modelValue.comprobantes[props.row.originalIndex].conciliado"
                                        }
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        id:
                                          "conciliado" +
                                          props.index +
                                          _vm.modelValue.title
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.modelValue.comprobantes[
                                            props.row.originalIndex
                                          ].conciliado
                                        )
                                          ? _vm._i(
                                              _vm.modelValue.comprobantes[
                                                props.row.originalIndex
                                              ].conciliado,
                                              null
                                            ) > -1
                                          : _vm.modelValue.comprobantes[
                                              props.row.originalIndex
                                            ].conciliado
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a =
                                              _vm.modelValue.comprobantes[
                                                props.row.originalIndex
                                              ].conciliado,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.modelValue.comprobantes[
                                                    props.row.originalIndex
                                                  ],
                                                  "conciliado",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.modelValue.comprobantes[
                                                    props.row.originalIndex
                                                  ],
                                                  "conciliado",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.modelValue.comprobantes[
                                                props.row.originalIndex
                                              ],
                                              "conciliado",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _c("span", [_vm._v(" ")])
                                  ]
                                )
                              ])
                            : props.column.field === "acciones"
                            ? _c("span", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-primary btn--text",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.cambiarVendedor(props.row)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-edit" })]
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      props.formattedRow[props.column.field]
                                    ) +
                                    "\n                            "
                                )
                              ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row mt-2" },
          [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-success btn--text",
                            on: { click: _vm.marcarTodos }
                          },
                          [
                            _c("i", { staticClass: "fa fa-check" }),
                            _c("span", [_vm._v("Marcar todos")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-danger btn--text",
                            on: { click: _vm.desmarcarTodos }
                          },
                          [
                            _c("i", { staticClass: "fa fa-times" }),
                            _c("span", [_vm._v("Desmarcar todos")])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "textarea-field",
                            {
                              attrs: {
                                placeholder: "Escriba una observación...",
                                id: "observacion" + _vm.$vnode.key
                              },
                              model: {
                                value: _vm.modelValue.observacion,
                                callback: function($$v) {
                                  _vm.$set(_vm.modelValue, "observacion", $$v)
                                },
                                expression: "modelValue.observacion"
                              }
                            },
                            [
                              _vm.errores.hasOwnProperty(
                                "vendedores." + _vm.index + ".observacion"
                              )
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores[
                                              "vendedores." +
                                                _vm.index +
                                                ".observacion"
                                            ][0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.moneyFormat(_vm.margen)) +
                            "\n                                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.moneyFormat(_vm.saldo_anterior)) +
                            "\n                                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.moneyFormat(_vm.modelValue.saldo)) +
                            "\n                                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.moneyFormat(_vm.comision)) +
                            "\n                                "
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "modal",
              {
                attrs: {
                  clickToClose: false,
                  name: "cambiarVendedor",
                  width: "50%",
                  height: "auto",
                  scrollable: ""
                }
              },
              [
                _c("cambiar-vendedor", {
                  attrs: {
                    vendedorId: _vm.currentVendedorId,
                    comprobanteId: _vm.currentComprobanteId,
                    vendedores: _vm.vendedores
                  },
                  on: {
                    vendedorCambiado: function($event) {
                      return _vm.$emit("vendedorCambiado")
                    },
                    cerrar: function($event) {
                      return _vm.$modal.hide("cambiarVendedor")
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Observación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Margen total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo anterior")]),
        _vm._v(" "),
        _c("th", [_vm._v("Saldo")]),
        _vm._v(" "),
        _c("th", [_vm._v("Comisión")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-640b2cb8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-640b2cb8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/cierre-comisiones/ItemCierreComisiones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-640b2cb8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/cierre-comisiones/ItemCierreComisiones.vue
// module chunks = 0